/*
  mx-cart.js (file name kept; brand-neutral contents)
  <cart-reserve-timer> - the "Cart reserved for mm:ss" bar at the top of the
  cart drawer (ported from Shrine's countdown_timer drawer block).

  - The deadline is stored in sessionStorage so the countdown survives page
    loads and the drawer's Section Rendering API re-renders (which replace the
    element: connectedCallback simply runs again and picks the deadline up).
  - At zero it shows 00:00 and stops. It never touches the cart.
  - Storage can throw (private mode, blocked site data); the timer then runs
    from the full duration for the lifetime of the element.
*/
(function () {
  if (customElements.get('cart-reserve-timer')) return;

  var STORAGE_KEY = 'cart-reserve-timer-deadline';

  function readDeadline() {
    try {
      var value = parseInt(window.sessionStorage.getItem(STORAGE_KEY), 10);
      return isNaN(value) ? null : value;
    } catch (e) {
      return null;
    }
  }

  function writeDeadline(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (e) {
      /* storage unavailable - keep the in-memory deadline */
    }
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function format(seconds) {
    var s = Math.max(0, Math.ceil(seconds));
    return pad(Math.floor(s / 60)) + ':' + pad(s % 60);
  }

  var memoryDeadline = null;

  class CartReserveTimer extends HTMLElement {
    connectedCallback() {
      var duration = parseInt(this.dataset.duration, 10);
      if (isNaN(duration) || duration <= 0) duration = 300;
      this.duration = duration;

      var now = Date.now();
      var deadline = readDeadline() || memoryDeadline;
      // A deadline further out than the configured duration means the setting
      // was shortened since it was stored: start again from the new duration.
      if (!deadline || deadline - now > duration * 1000) {
        deadline = now + duration * 1000;
        writeDeadline(deadline);
      }
      memoryDeadline = deadline;
      this.deadline = deadline;

      this.timeEls = this.querySelectorAll('[data-cart-timer]');
      this.tick = this.tick.bind(this);
      this.tick();
      if (this.remaining() > 0) this.interval = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      if (this.interval) window.clearInterval(this.interval);
      this.interval = null;
    }

    remaining() {
      return Math.max(0, (this.deadline - Date.now()) / 1000);
    }

    tick() {
      var remaining = this.remaining();
      var text = format(remaining);
      for (var i = 0; i < this.timeEls.length; i++) {
        if (this.timeEls[i].textContent !== text) this.timeEls[i].textContent = text;
      }
      if (remaining <= 0) {
        this.classList.add('mx-cart-timer--expired');
        if (this.interval) window.clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  customElements.define('cart-reserve-timer', CartReserveTimer);
})();
